// extracted by mini-css-extract-plugin
export default {"wrapper":"styles-module--wrapper--22pnj","BGMask":"styles-module--BGMask--3B39f"};